/**
 * **********************************************************************************************************************
 * Responsibility-  It renders its children only if a specified condition is true.  When the condition
 * is false, it renders nothing. 🐺
 * ********************************
 *
 * @format
 */

import React from 'react';

export const If = ({children, condition}) => {
    if (condition) {
        return <>{children}</>;
    }

    return <></>;
};
